import { PROFILE_DELETE_CODE_OVERLAY } from "shared/context/overlay/types"
import { useDeleteProfile } from "shared/lib/useDeleteProfile"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"

import { UseProfileDeleteOverlayViewModelProps } from "./useProfileDeleteOverlayViewModel"

export function useProfileDeleteOverlayModel(): UseProfileDeleteOverlayViewModelProps {
  const { openOverlay: openSubmitCodeOverlay } = useOverlay(
    PROFILE_DELETE_CODE_OVERLAY
  )
  const { requestCode } = useDeleteProfile()

  const handleSubmit = useEvent(() => {
    requestCode()
    openSubmitCodeOverlay(null)
  })

  return {
    onSubmit: handleSubmit
  }
}
